import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
// Shared Components
//    * Components: Header, Footer
//    * Services: All
import { SharedModule } from './shared/shared.module';

// Perfil visualizacion Publica
import { PublicoModule } from './publico/publico.module';

// Perfil visualizacion Coordinador
import { CoordinadorModule } from './coordinador/coordinador.module';

// Perfil visualizacion Coordinados
import { CoordinadosModule } from './coordinados/coordinados.module';

// Mantenedores sector Admin (Usuarios, Coordinados, Procesos, Notificaciones)
import { AdminModule } from './admin/admin.module';
import { NoAutorizadoInterceptor } from './shared/services/noAutorizado.interceptor';
import { RutPipe } from 'ng2-rut';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    SharedModule,
    AdminModule,
    PublicoModule,
    CoordinadorModule,
    CoordinadosModule,
    HttpClientModule,
    AppRoutingModule
  ],
  exports: [SharedModule],
  providers: [
    RutPipe,
    { provide: HTTP_INTERCEPTORS, useClass: NoAutorizadoInterceptor, multi: true }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
